import {Ability, AbilityBuilder} from '@casl/ability'
import * as routes from '../router/routes';

const ability = new Ability();
export default ability;

export function defineAbilitiesFor(roles) {
    const {rules, can} = AbilityBuilder.extract();
    roles.forEach((role) => {
        for (const key in routes) {
            if (routes[key].role === role) {
                can('manage', routes[key].name);
            }
        }
    });
    ability.update(rules);
}



// WEBPACK FOOTER //
// ./src/util/abilities.js